import React from "react";
import "./Applicant.css";
import { MDBDataTable } from "mdbreact";
import { RemoveScrollBar } from "react-remove-scroll-bar";
import Table from "react-bootstrap/Table";
import config4 from "../Util/config";
import { getToken } from "../Util/Authenticate";
import axios from "axios";
import { Link } from "react-router-dom";
import jwt from "jwt-decode";
import { useLocation } from "react-router-dom";
import { useState } from "react";
const EmployeePolicyTab = (props) => {
  const [tabs, setTabs] = React.useState([]);
  const userToken = localStorage.getItem("accessToken");
  const decodedToken = jwt(userToken);
  const [link, setLink] = useState(null);
  const location = useLocation();
  let tabId = props.tabId;
  const GetAttachmentbyTabID = () => {
    var data = "";
    var config = {
      method: "post",
      url: `${config4.BASE_URL}/api/Admin/GetAttachmentByTabID?tabID=${tabId}`,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        //console.log("Attachment API", JSON.stringify(response.data));
        setTabs(response.data);
      })
      .catch(function (error) {
        //console.log(error);
      });
  };

  const GetFile = (id) => {
    axios
      .get(`${config4.BASE_URL}/api/Admin/ViewFile?id=${id}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) setLink(res.data);
      });
  };
  React.useEffect(() => {
    GetAttachmentbyTabID();
    //console.log("Token", decodedToken.encrypted);
  }, []);
  const data = {
    columns: [
      {
        label: "#",
        field: "Number",
        sort: "asc",
      },
      {
        label: "Policy Name",
        field: "attachmentName",
        sort: "asc",
      },
      {
        label: "Policy URL",
        field: "attachment",
        sort: "asc",
      },
    ],
    rows: [
      ...tabs.map((data, i) => ({
        Number: i + 1,
        attachmentName: data.attachmentName,
        attachment: (
          <div>
            <a
              href={`${config4.BASE_URL}/api/Admin/ViewProtectedFile?id=${data.attachmentId}&token=${decodedToken.encrypted}`}
              target="_blank"
            >
              <button type="button" class="btn btn-outline-danger">
                View File
              </button>
            </a>
          </div>
        ),
      })),
    ],
  };
  return (
    <div>
      {/* <h3 class="ButtonFrame">Available Courses | الدورات المتاحة</h3> */}
      <hr class="solid"></hr>
      <div>
        <div className="row">
          <div className="col-lg">
            <Table responsive>
              <MDBDataTable
                className="text-left"
                striped
                bordered
                data={data}
                order={["Number", "asc"]}
                entries={10}
                hover
              />
              {/* <RemoveScrollBar /> */}
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeePolicyTab;
